import moment from 'moment'

export const getFormatUserDateUtil = (variables,) => ({
	...variables,
	blockedDate: variables.blockedDate ? moment(new Date(variables.blockedDate,),).format() : '',
})
